import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { reducer as agGridReducer } from '@client-shared/ui-agGrid';

import dashboardReducer from './dashboard/store/reducer';
import scenariosReducer from './scenarios/store/reducer';
import SharedReducer from './shared/store/reducer';
import ProvisionReducer from './provisionPage/store/reducer';
import BalanceSheetManagementReducer from './balanceSheetManagement/store/reducer';
import AdministrationReducer from './administration/store/reducer';
import ModalsReducer from './shared/modals/modals.reducer';
import ReportReducer from './reports/store/reducer';
import ReturnToProvisionReducer from './returnToProvision/store/reducer';
import UserReducer from './userData/store/reducer';
import UsersReducer from './userSettings/store/reducer';
import pageHelpReducer from './menu/shared/store/reducer';
import jimReducer from './shared/jim/store/reducer';

import { RESET_STATE } from './shared/store/types';

const rootReducer = combineReducers({
  balanceSheetManagement: BalanceSheetManagementReducer,
  dashboard: dashboardReducer,
  scenarios: scenariosReducer,
  shared: SharedReducer,
  provision: ProvisionReducer,
  toastr: toastrReducer,
  user: UserReducer,
  administration: AdministrationReducer,
  modals: ModalsReducer,
  returnToProvision: ReturnToProvisionReducer,
  reports: ReportReducer,
  users: UsersReducer,
  agGrid: agGridReducer,
  pageHelp: pageHelpReducer,
  jim: jimReducer,
});

const appReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    state = undefined; // eslint-disable-line no-undefined
  }

  return rootReducer(state, action);
};

export default appReducer;
